export default __webpack_public_path__ + "static/media/upload-image.a91cf85d.svg";